import React from 'react';
import { PillButton, BODY } from './clubUi';

/**
 * The lock card a gated club shows (README §1 "Lock card"): a black 52px circle with the lock,
 * the title 20/800, the body, and the CTA from `clubViewerState.lock`
 * (`THIS CLUB IS PRIVATE.` · `MEMBERS ONLY.` · `WAITING ON AN ADMIN.` · `YOU'RE INVITED.`).
 */
export default function ClubLockCard({ lock, onAction, mobile = false }) {
  if (!lock) return null;
  return (
    <section className="flex flex-col items-start bg-white font-mono" style={{ gap: 12, borderRadius: mobile ? 22 : 24, padding: mobile ? '18px 16px' : '22px 24px' }} data-testid="club-lock">
      <span className="flex items-center justify-center rounded-full bg-black text-white" style={{ width: 52, height: 52 }} aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square"><rect x="5" y="11" width="14" height="10" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
      </span>
      <span className="uppercase" style={{ fontSize: mobile ? 18 : 20, fontWeight: 800, letterSpacing: '.06em' }}>{lock.title}</span>
      <p className="m-0" style={{ maxWidth: 520, fontSize: 13, lineHeight: 1.65, color: BODY }}>{lock.body}</p>
      {lock.cta && lock.action && (
        <PillButton variant={lock.fill ? 'primary' : 'secondary'} size={48} padding="0 26px" fontSize={11} onClick={() => onAction?.(lock.action)} data-testid="lock-cta">{lock.cta}</PillButton>
      )}
    </section>
  );
}
